import { createTheme } from "@material-ui/core";

// Central design-system theme. Any component-level styling that should
// apply app-wide (typography, rounded corners, dialog/backdrop look) goes
// here instead of being re-declared per component.
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette: {
    primary: {
      main: "#ef7f1a",
    },
    background: {
      default: "#EEEEEE",
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: ['"Inter"', '"Roboto"', '"Helvetica Neue"', "Arial", "sans-serif"].join(","),
  },
  overrides: {
    MuiButton: {
      root: {
        borderRadius: 8,
        textTransform: "none",
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: 10,
      },
    },
    MuiCard: {
      root: {
        borderRadius: 10,
      },
    },
    MuiDialog: {
      paper: {
        borderRadius: 14,
      },
    },
    MuiBackdrop: {
      root: {
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        backdropFilter: "blur(3px)",
      },
    },
    MuiAppBar: {
      colorPrimary: {
        backgroundColor: "#ef7f1a",
      },
    },
    MuiChip: {
      root: {
        borderRadius: 8,
      },
    },
  },
});

export default theme;
